import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

interface CategoryInfo {
  name: string;
  sno: number;
}

const ALL_CATEGORY: CategoryInfo = { name: '전체', sno: -1 };

/**
 * 정렬/카테고리 칩 관련 로깅 모음. iOS `LikedProductLoggerType` 의
 * - `clickSort` → `CLICK_SORT`
 * - `applySort` → `APPLY_SORT`
 * - `applyCategory` → `APPLY_CATEGORY_CHIP_FILTER`
 * 와 동일. SCREEN 은 AnalyticsContext 에서 자동 주입.
 */
export const useLogSortAndCategory = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const logClickSort = useCallback(
    ({
      sortType,
      category,
    }: {
      sortType: string;
      category?: CategoryInfo;
    }) => {
      const c = category ?? ALL_CATEGORY;
      logAnalyticsEvent({
        name: 'CLICK_SORT',
        analytics: {
          SORT_TYPE: sortType,
          CATEGORY_NAME: c.name,
          CATEGORY_SNO: c.sno.toString(),
        },
      });
    },
    [logAnalyticsEvent],
  );

  const logApplySort = useCallback(
    ({
      sortType,
      category,
    }: {
      sortType: string;
      category?: CategoryInfo;
    }) => {
      const c = category ?? ALL_CATEGORY;
      logAnalyticsEvent({
        name: 'APPLY_SORT',
        analytics: {
          SORT_TYPE: sortType,
          CATEGORY_NAME: c.name,
          CATEGORY_SNO: c.sno.toString(),
        },
      });
    },
    [logAnalyticsEvent],
  );

  const logApplyCategory = useCallback(
    ({ category }: { category?: CategoryInfo }) => {
      const c = category ?? ALL_CATEGORY;
      logAnalyticsEvent({
        name: 'APPLY_CATEGORY_CHIP_FILTER',
        analytics: {
          CATEGORY_NAME: c.name,
          CATEGORY_SNO: c.sno.toString(),
        },
      });
    },
    [logAnalyticsEvent],
  );

  return { logClickSort, logApplySort, logApplyCategory };
};
